export const   fetched= 'SET_USER'
export const   fetching= 'FETCHING_USER'
export const   fetch= 'FETCH_USER'
export const   errored= 'ERROR_USER'
export const   update= 'UPDATE_USER'
export const   reset= 'RESET_USER'
